import { Component, Input, OnInit, OnChanges, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimelineModule } from 'primeng/timeline';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { DividerModule } from 'primeng/divider';
import { DialogModule } from 'primeng/dialog';
import { NGXLogger } from 'ngx-logger';
import { RichiesteService } from '../../../services/richieste.service';
import { StoricoContributo } from '../../../models/storico-contributo.model';
import { LottieComponent, AnimationOptions } from 'ngx-lottie';
import { Richiesta } from '../../../models/richiesta.model';

@Component({
  selector: 'app-storico-contributi',
  standalone: true,
  imports: [
    CommonModule,
    TimelineModule,
    CardModule,
    ButtonModule,
    TagModule,
    DividerModule,
    LottieComponent,
    DialogModule
  ],
  templateUrl: './storico-contributi.component.html',
  styleUrls: ['./storico-contributi.component.css']
})
export class StoricoContributiComponent implements OnInit, OnChanges {
  @Input() richiestaId!: number;
  @Input() richiesta: Richiesta | null = null;
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  eventi: StoricoContributo[] = [];
  isLoading: boolean = true;

  // Configurazione animazione Lottie
  lottieConfig: AnimationOptions = {
    path: 'assets/animations/spinner-storico-richiesta.json',
    autoplay: true,
    loop: true,
    renderer: 'svg'
  };
  animazione: any;

  constructor(
    private logger: NGXLogger,
    private richiesteService: RichiesteService
  ) { }

  ngOnInit(): void {
  }

  /**
   * Implementa OnChanges per reagire ai cambiamenti dell'input richiestaId
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['richiestaId']) {
      if (this.richiestaId && this.richiestaId > 0) {
        this.logger.info(`[STORICO-CONTRIBUTI] richiestaId cambiato da ${changes['richiestaId'].previousValue} a ${changes['richiestaId'].currentValue}`);
        this.isLoading = true;
        this.caricaEventiStorico();
      }
    }
  }

  /**
   * Caricamento completato dell'animazione Lottie
   */
  animationCreated(animation: any): void {
    this.animazione = animation;
    this.logger.info("[STORICO-CONTRIBUTI] Lottie animation created");
  }

  /**
   * Carica gli eventi dello storico contributi
   */
  caricaEventiStorico(): void {
    this.logger.info(`[STORICO-CONTRIBUTI] Caricamento eventi per la richiesta ${this.richiestaId}`);
    this.isLoading = true;
    this.richiesteService.getStoricoContributi(this.richiestaId).subscribe({
      next: (storicoContributi: StoricoContributo[]) => {
        this.eventi = storicoContributi;
        this.logger.info(`[STORICO-CONTRIBUTI] Eventi storico caricati: ${this.eventi.length}`);
        this.logger.info(this.eventi);
        this.isLoading = false;
      },
      error: (err) => {
        this.logger.error(`[STORICO-CONTRIBUTI] Errore nel caricamento eventi: ${err}`);
        this.isLoading = false;
      }
    });
  }

  show(richiesta: Richiesta) {
    this.richiestaId = richiesta.id;
    this.richiesta = richiesta;
    this.visible = true;
    this.visibleChange.emit(true);
    this.caricaEventiStorico();
  }

  hide() {
    this.visible = false;
    this.visibleChange.emit(false);
    this.richiesta = null;
    this.eventi = [];
    this.richiestaId = 0;
  }

  /**
   * Formatta la data in formato leggibile
   */
  formatDate(date: Date | string): string {
    const d = new Date(date);
    return d.toLocaleString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  /**
   * Formatta l'importo in formato valuta italiana
   */
  formatImporto(importo: number): string {
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR'
    }).format(importo);
  }
}
